import { Navigate, useLocation } from 'react-router-dom'

function hasAuthToken() {
  const raw = localStorage.getItem('dizeeToken')
  if (!raw) return false
  try {
    const parsed = JSON.parse(raw)
    return Boolean(parsed)
  } catch {
    return raw.trim().length > 0
  }
}

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  if (!hasAuthToken()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}

